export default __webpack_public_path__ + "static/media/mail.5ca2c4aa.png";